// Period imports use authoritative preview/commit and never fall back to client writes.
const previewBankPeriodImport = async (statement) => {
  const result = await bankReconciliationMutation('preview_period_import', { statement });
  return result.importSummary;
};
const importBankPeriodFile = async (statement, token, file) => {
  const result = await bankReconciliationMutation('import_period_file', { statement, token });
  const ids = result.importSummary.statementIds;
  const stored = await uploadBankStatementFile(file, statement.importId);
  let fileStored = Boolean(stored);
  if (stored) {
    for (const id of ids) {
      try { await bankReconciliationMutation('update_statement_file', { statementId: id, importId: statement.importId, file: stored }); }
      catch (error) { fileStored = false; console.warn('Bank import file reference could not be saved.', error); }
    }
  }
  // Reuse the coalesced background rule refresh rather than blocking a long import.
  if (result.importSummary.newCount > 0) scheduleBankSuggestionRulesRefresh();
  const first = safeArray(runtime.appState?.bankStatements).find((entry) => entry.id === ids[0]);
  return { ...mapBankStatementToUi(first), importSummary: { ...result.importSummary, fileStored } };
};
